import React from 'react';
import { useIntl } from 'react-intl-next';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { ToolTipContent, insertTaskList } from '@atlaskit/editor-common/keymaps';
import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { ToolbarButton, ToolbarTooltip, TaskIcon } from '@atlaskit/editor-toolbar';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
export var TaskListButton = function TaskListButton(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useEditorToolbar = useEditorToolbar(),
    editorView = _useEditorToolbar.editorView;
  if (!(editorView !== null && editorView !== void 0 && editorView.state.schema.nodes.taskItem)) {
    return null;
  }
  var onClick = function onClick() {
    if (editorView) {
      var _api$taskDecision;
      var state = editorView.state,
        dispatch = editorView.dispatch;
      api === null || api === void 0 || (_api$taskDecision = api.taskDecision) === null || _api$taskDecision === void 0 || _api$taskDecision.actions.insertTaskDecision('taskList', INPUT_METHOD.TOOLBAR)(state, dispatch);
    }
  };
  return /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: expValEquals('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? /*#__PURE__*/React.createElement(ToolTipContent, {
      description: formatMessage(messages.action),
      keymap: insertTaskList
    }) : formatMessage(messages.action)
  }, /*#__PURE__*/React.createElement(ToolbarButton, {
    iconBefore: /*#__PURE__*/React.createElement(TaskIcon, {
      label: formatMessage(messages.action),
      size: "small"
    }),
    onClick: onClick,
    ariaKeyshortcuts: "[ ] Space"
  }));
};